﻿
/*-------------------------------------------------------
'   @module: Opacc - Scroll Slider
'---------------------------------------------------------*/
export class OpcSlider {
    constructor() {
        this.sliderSelector = `[data-opc-slider]`;
        this.sliders = document.querySelectorAll(this.sliderSelector);

        if(this.sliders.length > 0) {
            this.initSliderConfig();
        }
    }

    /**
     * Initialize slider configuration.
     */
    initSliderConfig() {
        Array.from(this.sliders).forEach(slider => {
            const snapSlider = new SnapSlider(slider, {
                id: slider.dataset.opcSlider,
                slides: '.slide-item'
            });
        });
    }
}


new OpcSlider();